import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, Subject, catchError, map, of } from 'rxjs';
import { HttpAuthenticationProvider } from './http-authentication-provider';
import { HttpError } from './http-error';
import { HttpRequest } from './http-request';
import { HttpRequestClient } from './http-request-client';
import { HttpRequestBuilder } from './http-request.builder';
import { UserAuthService } from '@one/user-identity-access';
import { AuthCredential, AuthStorage } from '../../repositories/lib/auth';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomerPortalProvider extends HttpAuthenticationProvider {
  private req = new HttpRequestBuilder('/oauth');

  constructor(
    private oAuthService: UserAuthService,
    private authStorage: AuthStorage,
    private router: Router
  ) {
    super();
  }

  public override authenticate(request: HttpRequest): void {
    const creds = this.authStorage.cachedCredential;
    if (creds) {
      request.header('Authorization', 'Bearer ' + creds.idToken);
    }
  }

  public override onAccessForbidden(
    http: HttpRequestClient,
    req: HttpRequest,
    res: Observable<HttpResponse<any>>
  ): Observable<HttpResponse<any>> {
    return null as any;
  }

  public override onUnathenticated(
    http: HttpRequestClient,
    req: HttpRequest,
    res: Observable<HttpResponse<any>>,
    error?: HttpError | undefined
  ): Observable<boolean> {
    const creds = this.authStorage.getCredential();
    if (creds?.refreshToken && sessionStorage.getItem('username')) {
      return this.reauthenticate(creds.refreshToken).pipe(
        map((authResponse: any) => {
          const authResult = authResponse.AuthenticationResult;

          if (!authResult) {
            throw new Error('Invalid refresh response');
          }

          this.authStorage.setCredential(
            new AuthCredential(
              authResult.AccessToken,
              authResult.RefreshToken || creds.refreshToken,
              authResult.IdToken
            )
          );

          return true;
        }),
        catchError((_) => {
          this.authStorage.clear();
          this.router.navigate(['/']);
          return of(false);
        })
      );
    }

    return of(false);
  }

  private reauthenticate(refreshToken: string): Observable<any> {
    let username = sessionStorage.getItem('username');
    return this.oAuthService.refreshToken(username!, refreshToken);
  }
}
